import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Card, Grid, Icon } from "@mui/material";
import { useAuth } from "context/authContext";
import { useNavigate } from "react-router-dom";

function WelcomeEmpresa() {
  const { user } = useAuth();
  const companyName = user?.companyData?.nombre_empresa || "nuestro PMV";
  const navigate = useNavigate();

  const features = [
    {
      icon: "group_add",
      title: "Crear Candidatos",
      description: "Gestiona y organiza a todos tus candidatos de manera eficiente",
      route: "/gestion-candidato/cargar-candidatos"
    },
    {
      icon: "assignment",
      title: "Asignar licencias",
      description: "Asigna evaluaciones personalizadas y precisas",
      route: "/gestion-candidato/asignar-licencias"
    },
    {
      icon: "analytics",
      title: "Resultados Detallados",
      description: "Visualiza insights completos y toma mejores decisiones",
      route: "/informe-test"
    }
  ];

  //funcion para manejar el click en las 3 tarjetas
  const handleCardClick = (route) => {
    navigate(route); // usa navigate para cambiar de ruta sin recargar la página
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      
      {/* Hero Section */}
      <MDBox
        pt={8}
        pb={6}
        minHeight="70vh"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        position="relative"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.7),
              rgba(gradients.dark.state, 0.8)
            )}, url(${require('assets/images/fondo.png')})`,
          backgroundSize: "cover",
          backgroundAttachment: "fixed",
          borderRadius: "xl",
          margin: 3,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        {/* Logo Principal */}
        <MDBox
          component="img"
          src={require('assets/images/logo_koop/logo Quadrante H.png')}
          alt="Logo Quadrante H"
          sx={{
            maxWidth: { xs: "200px", md: "280px" },
            height: "auto",
            mb: 4,
            zIndex: 2,
            filter: "drop-shadow(0 4px 8px rgba(0,0,0,0.3))",
            animation: "fadeInUp 1s ease-out",
            "@keyframes fadeInUp": {
              "0%": {
                opacity: 0,
                transform: "translateY(30px)"
              },
              "100%": {
                opacity: 1,
                transform: "translateY(0)"
              }
            }
          }}
        />

        {/* Tarjeta de Bienvenida Principal */}
        <Card
          sx={{
            backdropFilter: "blur(15px)",
            backgroundColor: "rgba(255, 255, 255, 0.95)",
            borderRadius: "20px",
            border: "1px solid rgba(255, 255, 255, 0.2)",
            boxShadow: "0 20px 40px rgba(0, 0, 0, 0.1)",
            maxWidth: { xs: "90%", md: "600px" },
            p: { xs: 4, md: 6 },
            textAlign: "center",
            position: "relative",
            zIndex: 1,
            animation: "slideInUp 0.8s ease-out 0.3s both",
            "@keyframes slideInUp": {
              "0%": {
                opacity: 0,
                transform: "translateY(50px)"
              },
              "100%": {
                opacity: 1,
                transform: "translateY(0)"
              }
            }
          }}
        >
          <MDBox mb={3}>
            <MDTypography 
              variant="h2" 
              color="info" 
              textAlign="center" 
              fontWeight="bold"
              sx={{
                background: ({ palette: { gradients } }) => gradients.info.main,
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}
            >
              ¡Bienvenido a Quadrante H!
            </MDTypography>
          </MDBox>
          
          <MDBox mb={3}>
            <MDTypography variant="h4" color="dark" textAlign="center" fontWeight="medium">
              {companyName}
            </MDTypography>
          </MDBox>

          <MDTypography 
            variant="h6" 
            color="text" 
            textAlign="center" 
            fontWeight="regular"
            sx={{ lineHeight: 1.6, mb: 4 }}
          >
            Te invitamos a descubrir todas las herramientas que hemos preparado para 
            optimizar tus procesos de selección y evaluación de talento.
          </MDTypography>
        </Card>
      </MDBox>
 
      {/* Sección de Características */}
      <MDBox px={3} pb={6}>
        <MDBox mb={4} textAlign="center">
          <MDTypography variant="h3" color="dark" fontWeight="bold" mb={2}>
            ¿Qué puedes hacer con Quadrante H?
          </MDTypography>
          <MDTypography variant="body1" color="text" sx={{ maxWidth: "600px", mx: "auto" }}>
            Explora las principales funcionalidades de nuestra plataforma diseñada 
            para revolucionar tus procesos de recursos humanos
          </MDTypography>
        </MDBox>

        <Grid container spacing={4} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card
                onClick={() => handleCardClick(feature.route)}
                sx={{
                  height: "100%",
                  textAlign: "center",
                  p: 4,
                  borderRadius: "15px",
                  transition: "all 0.3s ease",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-10px)",
                    boxShadow: "0 15px 30px rgba(0, 0, 0, 0.15)"
                  }
                }}
              >
                <MDBox
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  width="80px"
                  height="80px"
                  borderRadius="50%"
                  sx={{
                    background: ({ palette: { gradients } }) => gradients.info.main,
                    mx: "auto",
                    mb: 3,
                    color: "white"
                  }}
                >
                  <Icon sx={{ fontSize: "2rem" }}>{feature.icon}</Icon>
                </MDBox>
                
                <MDTypography variant="h5" color="dark" fontWeight="bold" mb={2}>
                  {feature.title}
                </MDTypography>
                
                <MDTypography variant="body2" color="text" sx={{ lineHeight: 1.6 }}>
                  {feature.description}
                </MDTypography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </MDBox>

      {/* Call to Action Section */}
      <MDBox 
        px={3} 
        py={6}
        sx={{
          background: ({ palette: { gradients } }) => 
            `linear-gradient(135deg, ${gradients.info.main}, ${gradients.info.state})`,
          borderRadius: "20px",
          mx: 3,
          mb: 3
        }}
      >
        <MDBox textAlign="center" sx={{ color: "white" }}>
          <MDTypography variant="h3" fontWeight="bold" mb={2} color="white">
            ¿Listo para comenzar?
          </MDTypography>
          <MDTypography variant="h6" mb={4} color="white" sx={{ opacity: 0.9 }}>
            Comienza a crear tus candidatos y descubre el poder de Quadrante H
          </MDTypography>
          <MDButton 
            variant="contained" 
            color="white"
            size="large"
            sx={{
              color: "info.main",
              px: 5,
              py: 1.5,
              borderRadius: "10px",
              fontWeight: "bold",
              "&:hover": {
                transform: "scale(1.05)"
              },
              transition: "all 0.3s ease"
            }}
            onClick={() => navigate('/gestion-candidato/cargar-candidatos')}
          >
            Explorar Dashboard
          </MDButton>
        </MDBox>
      </MDBox>

      <Footer />
    </DashboardLayout>
  );
}

export default WelcomeEmpresa;